import React from "react";
import { PartCard } from "./UI/PartCard";
import { PartTable } from "./UI/PartTable";

import { CrudlStatus, ValidateState } from "../../common/config/AppConstants";
import { MVVMToolbar } from "../Common/MVVMToolbar";
import { LoadScreen } from "../Common/LoadScreen";
import { ViewState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";

import { MVVMValidateDialog } from "../Common/MVVMValidateDialog";
export class PartView extends React.Component {
  render() {
    return (
      <div>
        <div
          className="ui-g dashboard"
          style={this.props.loading === true ? { pointerEvents: "none" } : {}}
        >
          {this.props.viewState === ViewState.CARD && (
            <React.Fragment>
              <MVVMValidateDialog
                header="Part"
                isVisible={this.props.validateState === ValidateState.CONFIRM}
                visibleField="validateState"
                updateVisibility={this.props.updateState}
                runConfirm={this.props.discardChanges}
                message={"Discard Changes?"}
              />
              <MVVMValidateDialog
                header="Delete Part"
                isVisible={this.props.validateState === ValidateState.DELETE}
                visibleField="validateState"
                updateVisibility={this.props.updateState}
                message={" Are you sure you want to delete?"}
                type={"CRUDL"}
                crudlExecute={this.props.crudlExecute}
                crudlState={this.props.crudlState}
              />
              <pr.Sidebar
                visible={true}
                fullScreen={true}
                onHide={e => {
                  this.props.discardChanges();
                }}
              >
                <PartCard
                  loading={this.props.loading}
                  crudlState={this.props.crudlState}
                  crudlControl={this.props.crudlControl}
                  updateValue={this.props.updateEdited}
                  updateState={this.props.updateState}
                  editedObject={this.props.editedObject}
                  checkRequiredFields={this.props.checkRequiredFields}
                  discardChanges={this.props.discardChanges}
                  validateState={this.props.validateState}
                  validateChanges={this.props.validateChanges}
                  crudlExecute={this.props.crudlExecute}
                  //PART SPECIFIC
                  stockTypeOptions={this.props.stockTypeOptions}
                  operationalTypeOptions={this.props.operationalTypeOptions}
                  attributeSetMap={this.props.attributeSetMap}
                  supplierMap={this.props.supplierMap}
                  stationMap={this.props.stationMap}
                  selectAttributeSet={this.props.selectAttributeSet}
                  updateAttributeProperties={
                    this.props.updateAttributeProperties
                  }
                  selectedAttributeSet={this.props.selectedAttributeSet}
                />
              </pr.Sidebar>
            </React.Fragment>
          )}
          {this.props.viewState === ViewState.TABLE && (
            <React.Fragment>
              <PartTable
                //CUSTOMISATION
                tableReference={this.props.tableReference}
                tableColumns={this.props.tableColumns}
                columnOptions={this.props.columnOptions}
                columnToggle={this.props.columnToggle}
                expandedRows={this.props.expandedRows}
                rowCount={this.props.rowCount}
                settingsToggle={this.props.settingsToggle}
                //
                updateState={this.props.updateState}
                partList={this.props.partList}
                crudlControl={this.props.crudlControl}
                validateState={this.props.validateState}
                menuState={this.props.menuState}
                crudlState={this.props.crudlState}
                loading={this.props.loading}
                refresh={this.props.refresh}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Part/PartView.js